import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ContractNav from '../components/ContractNav';
import ContractSummary from '../components/ContractSummary';
import Actions from '../actions';
import { fieldDefinitionsToContractSummaryClasses } from '../utilities/helpers';
import './ContractsContainer.css';

function mapDispatchToProps(dispatch) {
  return {
    launchContractToggle(tokenName) {
      dispatch(Actions.launchedContractToggle(tokenName));
    },
  };
}

function mapStateToProps(state) {
  return {
    contracts: state.contracts.contracts,
    contractToggles: state.contracts.contractToggles,
    //  eslint-disable-next-line max-len
    contractSummaryClasses: fieldDefinitionsToContractSummaryClasses(state.contractForm.fieldDefinitionsSerializable),
  };
}

class ContractsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleLaunchContractToggle = this.handleLaunchContractToggle.bind(this);
  }
  componentDidMount() {
    // here it would be fetchedContracts.
  }
  handleLaunchContractToggle(event) {
    const tokenIndex = event.target.attributes.data.value;
    event.preventDefault();
    const { launchContractToggle } = this.props;
    launchContractToggle(tokenIndex);
  }
  render() {
    const { contracts, contractToggles, contractSummaryClasses } = this.props;

    let toggleRowClass = 'odd';
    const contractList = contracts.map((contract) => {
      const anchorAction = contractToggles[contract.id] ? 'close' : 'open';
      // Use anchor for toggle control for now, but link to nowhere.
      /* eslint-disable jsx-a11y/anchor-is-valid */
      const contractRow = (
        <div className={`contract-row ${toggleRowClass}`} key={contract.id}>
          <span>Token Name:</span> <strong>{contract.name}</strong>
          <Link
            href=""
            to=""
            className={`toggle ${anchorAction}`}
            onClick={this.handleLaunchContractToggle}
            data={contract.id}
          />
          {contractToggles[contract.id] && (
            <ContractSummary
              contract={contracts[contract.id]}
              contractSummaryClasses={contractSummaryClasses}
            />
          )}
        </div>
      );
      /* eslint-enable */
      toggleRowClass = toggleRowClass === 'odd' ? 'even' : 'odd';
      return contractRow;
    });

    const contractsPresent = contracts.length > 0;

    /* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/href-no-hash */
    return (
      <div>
        <div className="page-title">
          <h1>Manage Contracts</h1>
        </div>
        <ContractNav />

        <div className="contracts white-box item-box">
          <div className="row">
            <div className="col s12">
              <h2>My Contracts</h2>
              {!contractsPresent && <p>You do not have any contracts yet. Go create one!</p>}
              {contractsPresent && <div className="contracts-list">{contractList}</div>}
            </div>
          </div>
        </div>
      </div>
    );
    /* eslint-enable jsx-a11y/anchor-is-valid */
  }
}
/* eslint-disable react/forbid-prop-types */
ContractsContainer.propTypes = {
  contracts: PropTypes.array.isRequired,
  contractToggles: PropTypes.object.isRequired,
  contractSummaryClasses: PropTypes.object.isRequired,
  /* eslint-disable react/forbid-prop-types */
  launchContractToggle: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractsContainer);



// WEBPACK FOOTER //
// ./src/containers/ContractsContainer.js